import { render, staticRenderFns } from "./dimission.vue?vue&type=template&id=7217852a&scoped=true&"
import script from "./dimission.vue?vue&type=script&lang=js&"
export * from "./dimission.vue?vue&type=script&lang=js&"
import style0 from "./dimission.vue?vue&type=style&index=0&id=7217852a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7217852a",
  null
  
)

export default component.exports